import { makeActionCreator } from "features/Application/actions/actionsBuilder";
import * as accountInformationActionTypes from "./accountInformationActionTypes";

export const updateData = makeActionCreator(accountInformationActionTypes.UPDATE_DATA, "accountInfo");
